// Test IDs for Archi Travel Guide site-wide + page-specific elements.

export const NAV = {
	logo: 'nav-logo',
	linkSiena: 'nav-link-siena',
	linkTuscany: 'nav-link-tuscany',
	linkTravelTools: 'nav-link-travel-tools',
	linkTravelDeals: 'nav-link-travel-deals',
	linkBlog: 'nav-link-blog',
	linkAbout: 'nav-link-about',
	linkContact: 'nav-link-contact',
	mobileMenuButton: 'nav-mobile-menu-button',
	mobileMenuClose: 'nav-mobile-menu-close',
	mobileMenuPanel: 'nav-mobile-menu-panel',
	searchInput: 'nav-search-input',
	searchSubmit: 'nav-search-submit',
};

export const HERO = {
	container: 'home-hero',
	title: 'home-hero-title',
	searchInput: 'home-hero-search-input',
	searchSubmit: 'home-hero-search-submit',
	ctaExplore: 'home-hero-cta-explore',
	ctaTools: 'home-hero-cta-tools',
};

export const HOME_SECTION = {
	featuredItaly: 'home-featured-italy',
	destinationGrid: 'home-destination-grid',
	featuredGuides: 'home-featured-guides',
	toolsPreview: 'home-tools-preview',
	newsletterForm: 'home-newsletter-form',
	newsletterEmail: 'home-newsletter-email',
	newsletterSubmit: 'home-newsletter-submit',
	trust: 'home-trust',
};

export const TOOLS = {
	// Budget calculator
	budgetForm: 'tool-budget-form',
	budgetDestination: 'tool-budget-destination',
	budgetTravelers: 'tool-budget-travelers',
	budgetLength: 'tool-budget-length',
	budgetAccommodation: 'tool-budget-accommodation',
	budgetFood: 'tool-budget-food',
	budgetTransport: 'tool-budget-transport',
	budgetActivities: 'tool-budget-activities',
	budgetSubmit: 'tool-budget-submit',
	budgetResult: 'tool-budget-result',
	// Itinerary
	itinForm: 'tool-itinerary-form',
	itinDestination: 'tool-itinerary-destination',
	itinLength: 'tool-itinerary-length',
	itinSubmit: 'tool-itinerary-submit',
	itinResult: 'tool-itinerary-result',
	// Area finder
	areaForm: 'tool-area-form',
	areaDestination: 'tool-area-destination',
	areaBudget: 'tool-area-budget',
	areaStyle: 'tool-area-style',
	areaTransport: 'tool-area-transport',
	areaNightlife: 'tool-area-nightlife',
	areaFamily: 'tool-area-family',
	areaSubmit: 'tool-area-submit',
	areaResult: 'tool-area-result',
	// Packing
	packForm: 'tool-packing-form',
	packDestination: 'tool-packing-destination',
	packSeason: 'tool-packing-season',
	packLength: 'tool-packing-length',
	packSubmit: 'tool-packing-submit',
	packResult: 'tool-packing-result',
	// Best time
	btForm: 'tool-besttime-form',
	btDestination: 'tool-besttime-destination',
	btPreference: 'tool-besttime-preference',
	btSubmit: 'tool-besttime-submit',
	btResult: 'tool-besttime-result',
};

export const CONTACT = {
	form: 'contact-form',
	name: 'contact-name',
	email: 'contact-email',
	subject: 'contact-subject',
	message: 'contact-message',
	submit: 'contact-submit',
};

export const COOKIE = {
	banner: 'cookie-banner',
	accept: 'cookie-accept',
	decline: 'cookie-decline',
};
